export default "__VITE_ASSET__CEzpFPPx__"